interface GamePlaceholderProps {
  className?: string;
}

export function GamePlaceholder({ className = "" }: GamePlaceholderProps) {
  return (
    <div
      className={`flex h-full w-full items-center justify-center bg-gradient-to-br from-primary-50 via-blue-50 to-purple-50 ${className}`}
    >
      <svg
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-2/5 w-2/5 max-h-24 max-w-24 opacity-40"
      >
        {/* Dice */}
        <rect
          x="20"
          y="30"
          width="50"
          height="50"
          rx="8"
          stroke="currentColor"
          strokeWidth="3"
          className="text-primary-400"
          fill="none"
        />
        {/* Dice dots */}
        <circle cx="35" cy="45" r="3.5" className="fill-primary-300" />
        <circle cx="55" cy="45" r="3.5" className="fill-primary-300" />
        <circle cx="35" cy="65" r="3.5" className="fill-primary-300" />
        <circle cx="55" cy="65" r="3.5" className="fill-primary-300" />
        <circle cx="45" cy="55" r="3.5" className="fill-primary-300" />
        {/* Meeple */}
        <path
          d="M90 90c0-8-5-14-10-14s-10 6-10 14h20zm-10-18a6 6 0 100-12 6 6 0 000 12z"
          stroke="currentColor"
          strokeWidth="3"
          className="text-purple-300"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
